import { CheckBox, Collapsible, Flex, InputContainer, MarkdownEditor, TextField } from 'components'
import { FollowUpRegistrationConsent } from 'types'
import { useRegistrationConsent } from './RegistrationConsentProvider'

export default function FollowUpRegistrationConsentEditor() {
  const { consent, updateConsent } = useRegistrationConsent()

  function update(updates: Partial<FollowUpRegistrationConsent>) {
    updateConsent({ followUp: { ...consent?.followUp!, ...updates } })
  }

  const { hide, title, description } = consent?.followUp || {}

  return (
    <Flex direction="column" gap={4}>
      <CheckBox checked={hide || false} onChange={hide => update({ hide: !!hide })}>
        Disable follow up
      </CheckBox>

      <Collapsible open={!hide}>
        <Flex direction="column" gap={4}>
          <TextField
            label="Title"
            value={title?.en || 'Interested in a Follow Up?'}
            onChange={e => update({ title: { en: e.target.value } })}
            disabled={hide}
          />

          <InputContainer label="Description">
            <MarkdownEditor
              value={
                description?.en ||
                'A representative from the company will reach out to you after the event.'
              }
              onChange={en => update({ description: { en } })}
            />
          </InputContainer>
        </Flex>
      </Collapsible>
    </Flex>
  )
}
